import React from 'react';
import styled from 'styled-components'
import get from 'lodash/get'
import SectionTitle from '../../common/Section/SectionTitle';
import { BLOCKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Theme from '../../../vars/ThemeOptions';
import GatsbyImage from 'gatsby-image';
 
const Wrap = styled.div`
  * {
    transition: all .3s ease;
  }
  margin-top: -1rem;
  h5 {
    font-weight: normal;
    font-style: italic;
    font-size: 1rem;
    margin-top: -1rem;
  }
  h6 {
    font-weight: normal;
    font-size: .8rem;
    color: ${Theme.hex('primary')};
  }
  h3 {
    font-size: .8rem;
    margin-top: 2rem;
  }
`
const ImgWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  width: 100%;
  .gatsby-image-wrapper {
    width: 80%;
  }
`
 
const DoubleChances = ({ data }) => {
  // console.log('data: ', data);
  const richText1 = get(data, 'richText1');
  const json = get(richText1, 'json');
  const titleCopy = get(json, 'content[0].content[0].value') + get(json, 'content[0].content[1].value');
  
  const fileRef = get(data, 'fileRef');
  const fluid = get(fileRef, 'fluid');
  const imgTitle = get(fileRef, 'title');

  const options = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: () => null,
    }
  };
  return (
    <Wrap>
      <ImgWrap>
        <GatsbyImage fluid={fluid} alt={imgTitle} />
      </ImgWrap>   
      <SectionTitle copy={titleCopy} titleColor="black" bold />
      {documentToReactComponents(json, options)}  
    </Wrap>
  )
}
 
export default DoubleChances